import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseCached = (store: StoreSchema) => store.license.cachedLicense
